import type { Moment } from 'moment'
import { rem } from 'polished'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

import BodyText from 'LuxKit/Typography/BodyText'
import { INTL_SHORT_DAY_NAME_DAY_MONTH_YEAR, INTL_SHORT_TIME_FORMAT_AM_PM } from 'constants/dateFormats'
import { intlDateFormatter } from 'lib/datetime/dateUtils'

const DateTime = styled.div`
  display: flex;
  flex-direction: column;
  font-weight: ${(props) => props.theme.font.primary.weight.regular};
  font-size: ${rem(14)};
  line-height: ${rem(24)};
`

type Props = {
  title: string
  date?: Moment
  time?: Moment
  day?: number
}

function DateTimeBlock({ title, date, time, day }: Props) {
  const intl = useIntl()

  if (!date && !time && !day) return null

  const dayLabel = intl.formatMessage(
    {
      id: 'dG1AENpVne-AbZRDUBdn',
      defaultMessage: 'Day {day}',
      description: 'Day number label in trip itinerary in the trip planner feature',
    },
    { day },
  )

  return (
    <DateTime>
      <BodyText variant="medium" weight="bold">
        {title}
      </BodyText>
      {day && <BodyText variant="large">{dayLabel}</BodyText>}
      {!day && date && (
        <BodyText variant="large">
          {intlDateFormatter(date, INTL_SHORT_DAY_NAME_DAY_MONTH_YEAR, intl.locale)}
        </BodyText>
      )}
      {time && <BodyText variant="large">{intlDateFormatter(time, INTL_SHORT_TIME_FORMAT_AM_PM, intl.locale)}</BodyText>}
    </DateTime>
  )
}

export default DateTimeBlock
